import { Injectable } from '@angular/core';
import { RequestParams } from '../models/requestParams';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlanogramCompletion } from '../models/planogramCompletion';
import { ISearchSettings } from '../../product/models/models';
import { ITableSettingColumnsData } from '../models/tableSettingColumn';
import { IUserTableSettings } from '../models/userTableSettings';
import { SessionService } from './session.service';

const ROOT_URL: string = '/api/v1/reports/planogram-completion/';

@Injectable()
export class PlanogramCompletionService {

	private _data: PlanogramCompletion;
    private _columns: ITableSettingColumnsData;
	planId: number;
	planogramId: number;
	requestParams: RequestParams;
	searchSettings: Array<ISearchSettings>;

	constructor(private http: HttpClient, private sessionService: SessionService) {
		this.requestParams = new RequestParams();

        const userTableSettings: IUserTableSettings = this.sessionService.settings.planogramCompletionTable;

        // if there are saved user table settings
		if (userTableSettings?.columns) {
			this.requestParams.updateParams({ metrics: userTableSettings.columns });
		}

		const searchSettings = JSON.parse(localStorage.getItem('planogramCompletionSearchSettings'));
		this.searchSettings = [
			{
				title: 'PRODUCT_CARD.SEARCH_BY_ARTICLE',
				selected: searchSettings ? searchSettings['article'] : false,
				name: 'article'
			},
			{
				title: 'PRODUCT_CARD.SEARCH_BY_BARCODE',
				selected: searchSettings ? searchSettings['barcode'] : false,
				name: 'barcode'
			},
			{
				title: 'PRODUCT_CARD.SEARCH_BY_NAME',
				selected: searchSettings ? searchSettings['product_name'] : false,
				name: 'product_name'
			}
		];

		if (this.searchOptionsActive) {
			const searchFields: Array<string> = this.searchSettings
				.filter((setting: ISearchSettings) => setting.selected)
				.map((setting: ISearchSettings) => setting.name);
			this.requestParams.updateParams({ search_fields: searchFields });
		}
	}

    set columns(data: ITableSettingColumnsData) {
        this._columns = data;
    }

    get columns(): ITableSettingColumnsData {
        return this._columns;
    }

	set data(data: PlanogramCompletion) {
		this._data = data;
	}

	get data(): PlanogramCompletion {
		return this._data;
	}

	get searchOptionsActive(): boolean {
		const selectedLength: number = this.searchSettings.filter((option: ISearchSettings) => option.selected).length;
		return selectedLength > 0 && selectedLength < this.searchSettings.length;
	}

	getData(id: number, planId: number, params: any): Observable<PlanogramCompletion> {
		if (params?.search_fields) {
			params.search_fields = [params.search_fields, 'block_name'].join(',');
		}

		return this.http.get<PlanogramCompletion>(ROOT_URL, {
			params: new HttpParams({
				fromObject: {
					planogram_id: id,
					plan_id: planId,
					...params
				}
			})
		});
	}

    getColumns(): Observable<ITableSettingColumnsData> {
        return this.http.get<ITableSettingColumnsData>(`${ROOT_URL}columns/`);
    }
}
